<div class="flex flex-row justify-between mb-2">
    <div class="flex flex-col pr-8">
        <label class="block uppercase text-blueGray-600 text-xs font-bold">
            {{label}}
        </label>
        <p class="text-xs text-primary-300">{{description}}</p>
    </div>
    <button type="button" [disabled]="!markerPosition" (click)="clearMarker()"
        class="bg-red-500 hover:bg-primary-500 active:bg-primary-500 disabled:bg-primary-200 focus:outline-none whitespace-nowrap h-fit w-fit text-white font-bold text-xs uppercase rounded px-2 py-2">
        <i class="fa-regular fa-trash-can mr-2 leading-relaxed"></i>Delete
    </button>
</div>
@if (options) {
<google-map height="300px" width="100%" [options]="options" (mapClick)="addMarker($event)">
    @if (markerPosition) {
        <map-advanced-marker [position]="markerPosition" [options]="markerOptions" [content]="markerContent" class="rounded" />
    }
</google-map>
}